import * as React from 'react';
import Transfer, { TransferDirection } from 'antd/lib/transfer';

import { Permission, Role } from 'core/domain';

import './edit.scss';
import { getViaAuth, postViaAuth, responseValidator } from 'apis/api';
import { Spin } from 'antd';
import TextArea from 'antd/lib/input/TextArea';
import { useNavigate } from 'react-router-dom';
import { API } from 'apis';
import { Button, buttonType } from 'components/button/button';
import { Input } from 'components/input/input';
import { toast } from 'react-hot-toast';
import { getRoleById } from 'core/repositories/roles';

const { useState, useRef, useEffect } = React;

type GoogleAuth = {
    code?: string;
    error?: string;
};

type MenuItem = {
    id: string;
    name: string;
    path?: string;
    parent?: string;
};

const permissionsData: any[] = Array.from({ length: 10 }).map((_, i) => ({
    key: i.toString(),
    displayText: `دسترسی ${i + 1}`,
}));

const initialTargetKeys = permissionsData.filter((item) => Number(item.id) > 10).map((item) => item.id.toString());

export const EditRole: React.FC = () => {
    // States
    const [modalIsOpen, setModalIsOpen] = useState<boolean>(false);
    const [isCardLoading, setIsCardLoading] = useState<boolean>(false);
    const [loading, setLoading] = useState<boolean>(false);

    const [roleData, setRoleData] = useState<Role>();
    const [targetKeys, setTargetKeys] = useState<string[]>([]);

    const [permissions, setPermissions] = useState<Permission[]>([]);
    const [selectedPermissions, setSelectedPermissions] = useState<string[]>([]);

    const [role, setRole] = useState<any>();

    const [menuItems, setMenuItems] = useState<MenuItem[]>([]);
    const [selectedMenuKeys, setSelectedMenuKeys] = useState<string[]>([]);
    const [targetMenuKeys, setTargetMenuKeys] = useState<string[]>([]);

    const roleId = window.location.pathname.split('/')[window.location.pathname.split('/').length - 1];
    const navigate = useNavigate();

    const editRoleHandle = async () => {
        console.log('targetKeys before submit:', targetKeys);
        console.log(
            'claims payload:',
            targetKeys?.map((key) => parseInt(key)),
        );
        setLoading(true);
        await postViaAuth(API.roles.edit, {
            id: roleId,
            name: roleData?.title,
            title: roleData?.title,
            claims: targetKeys?.map((key) => parseInt(key)),
            description: roleData?.description,
            menuItems: targetMenuKeys, // An array of GUID strings
        }).then((response: any) => {
            setLoading(false);
            if (responseValidator(response.status)) {
                setModalIsOpen(false);
                toast.success('نقش مورد نظر با موفقیت اصلاح شد.');
                navigate('/dashboard/roles/');
            }
        });
    };

    const onChange = (nextTargetKeys: string[], direction: TransferDirection, moveKeys: string[]) => {
        setTargetKeys(nextTargetKeys);
    };

    const onSelectChange = (sourceSelectedKeys: string[], targetSelectedKeys: string[]) => {
        setSelectedPermissions([...sourceSelectedKeys, ...targetSelectedKeys]);
    };

    const onMenuItemsChange = (nextTargetKeys: string[]) => {
        setTargetMenuKeys(nextTargetKeys);
    };

    const onMenuItemsSelectChange = (sourceSelectedKeys: string[], targetSelectedKeys: string[]) => {
        setSelectedMenuKeys([...sourceSelectedKeys, ...targetSelectedKeys]);
    };

    const onScroll = (direction: TransferDirection, e: React.SyntheticEvent<HTMLUListElement>) => {};

    async function getAllPermissions() {
        const arr = [];
        setIsCardLoading(true);
        await getViaAuth(API.roles.permissions).then((response: any) => {
            setIsCardLoading(false);
            if (responseValidator(response.status) && response.value) {
                response.value.forEach((p) =>
                    arr.push({
                        key: String(p.key),
                        displayText: p.displayText,
                        title: p.displayText,
                    }),
                );
                setPermissions(arr);
            }
        });
    }

    async function getMenuItems() {
        const arr = [];
        setIsCardLoading(true);
        await getViaAuth(API.roles.menuItems).then((response: any) => {
            setIsCardLoading(false);
            if (responseValidator(response.status) && response.value) {
                response.value.forEach((mi) =>
                    arr.push({
                        key: mi.id,
                        name: mi.name,
                    }),
                );
                setMenuItems(arr);
            }
        });
    }

    async function fetch() {
        await getAllPermissions();
        await getMenuItems();
        getRoleById(setIsCardLoading, setRoleData, setTargetKeys, setTargetMenuKeys, roleId);
    }

    useEffect(() => {
        fetch();
    }, []);

    return (
        <>
            <Spin spinning={isCardLoading} tip="درحال بارگذاری">
                <div className="pmx-dashboard-roles-edit">
                    <h3>اصلاح نقش</h3>

                    <form>
                        <Input
                            label="عنوان"
                            value={roleData?.title}
                            onChange={(e) => setRoleData({ ...roleData, title: e.target.value })}
                            name="title"
                            placeholder="عنوان نقش را وارد کنید"
                        />

                        <TextArea
                            name="description"
                            value={roleData?.description}
                            onChange={(e) => setRoleData({ ...roleData, description: e.target.value })}
                            placeholder="توضیحات نقش را وارد کنید"
                        />
                        {permissions.length > 0 && (
                            <Transfer
                                className="roles-transfer"
                                dataSource={permissions}
                                titles={['لیست دسترسی ها', 'دسترسی های نقش']}
                                targetKeys={targetKeys}
                                selectedKeys={selectedPermissions}
                                onChange={onChange}
                                onSelectChange={onSelectChange}
                                onScroll={onScroll}
                                render={(item) => item.displayText}
                                locale={{
                                    itemUnit: 'مورد',
                                    itemsUnit: 'مورد',
                                    selectAll: 'انتخاب همه',
                                    selectCurrent: 'تایید موارد انتخاب شده',
                                    selectInvert: 'معکوس کردن انتخاب ها',
                                }}
                            />
                        )}
                        {menuItems.length > 0 && (
                            <Transfer
                                className="menu-items-transfer"
                                dataSource={menuItems}
                                titles={['لیست آیتم های منو', 'آیتم های منو نقش']}
                                targetKeys={targetMenuKeys}
                                selectedKeys={selectedMenuKeys}
                                onChange={onMenuItemsChange}
                                onSelectChange={onMenuItemsSelectChange}
                                onScroll={onScroll}
                                render={(item) => item.name}
                                locale={{
                                    itemUnit: 'مورد',
                                    itemsUnit: 'مورد',
                                    selectAll: 'انتخاب همه',
                                    selectCurrent: 'تایید موارد انتخاب شده',
                                    selectInvert: 'معکوس کردن انتخاب ها',
                                }}
                            />
                        )}

                        <div className="buttons">
                            <Button
                                type={buttonType.info}
                                text="اصلاح"
                                onClick={() => editRoleHandle()}
                                loading={loading}
                                htmlType="button"
                                disabled={!roleData?.title || !roleData?.description}
                            />
                            <Button
                                type={buttonType.outlined}
                                text="بازگشت"
                                onClick={() => navigate('/dashboard/roles/')}
                                htmlType="button"
                            />
                        </div>
                    </form>
                </div>
            </Spin>
        </>
    );
};
